// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import { useLoginCallbackUrl } from 'src/modules/config';

import { UserActionRow } from './UserActionRow';

function LoginRow(): React.MixedElement {
  const { __ } = useTranslator();

  const href = useLoginCallbackUrl();

  return (
    <UserActionRow
      href={href}
      message={__(
        'You can log in to see which products need renewal at this time.',
      )}
      buttonLabel={__('Log in')}
    />
  );
}

export default LoginRow;
